import { render, staticRenderFns } from "./CotizationHistory.vue?vue&type=template&id=fb6788f8&scoped=true"
import script from "./CotizationHistory.vue?vue&type=script&lang=js"
export * from "./CotizationHistory.vue?vue&type=script&lang=js"
import style0 from "./CotizationHistory.vue?vue&type=style&index=0&id=fb6788f8&prod&lang=scss&scoped=true"
import style1 from "./CotizationHistory.vue?vue&type=style&index=1&id=fb6788f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb6788f8",
  null
  
)

export default component.exports